import { useT } from "../lib/i18n";
import type { EsperaKeeper } from "../hooks/useEsperaKeeper";

/**
 * El PIE DE TEXTO que acompaña al robot cuando la posición está fuera de rango. El robot en sí
 * camina por la barra REAL del rango (ver `Banda`, prop `reajustando`); esto solo explica en
 * palabras qué está haciendo. Se muestra en la ficha justo debajo de la banda cuando `!enRango`.
 *
 * Y CUANDO NO ESTÁ REAJUSTANDO, DICE POR QUÉ. Si el robot está aplazando el reajuste a propósito
 * —porque el gas de la red está caro y esperar sale mucho más barato— hay que contarlo: sin eso, un
 * robot que espera y un robot averiado se ven exactamente igual, y el dueño no puede distinguirlos.
 */
export function RobotReajustando({ espera }: { espera?: EsperaKeeper | null }) {
  const t = useT();

  if (espera?.motivo === "gas") {
    const minutos = Math.round(espera.esperando_s / 60);
    const restan = Math.max(0, Math.round((espera.tope_s - espera.esperando_s) / 60));
    return (
      <p className="robot-reajuste-cap robot-espera" role="status" aria-live="polite">
        <b>{t("El robot está esperando a que baje el gas…")}</b>{" "}
        <span>
          {t("la red está a {g} gwei y reajusta por debajo de {u}. Lleva {m} min esperando; si no baja, reajusta igual en {r} min.", {
            g: espera.gwei.toFixed(3), u: String(espera.umbral), m: String(minutos), r: String(restan),
          })}
        </span>{" "}
        <span className="tenue">
          {t("Reajustar con el gas caro puede costar diez veces más, y tu rango no cambia por esperar unos minutos.")}
        </span>
      </p>
    );
  }

  return (
    <p className="robot-reajuste-cap" role="status" aria-live="polite">
      <b>{t("El robot está reajustando tu rango…")}</b>{" "}
      <span>{t("moviendo los precios a donde tu liquidez vuelve a cobrar")}</span>
    </p>
  );
}
